import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  ICFDISyncInformation,
  IComplianceSyncInformation,
  ISharedDataState,
} from './sharedData.models'

const initialState: ISharedDataState = {
  bottomToast: {
    open: false,
    message: '',
  },
  syncInformation: {
    cfdis: [],
    compliance: [],
  },
}

export const sharedDataSlice = createSlice({
  name: 'sharedData',
  initialState,
  reducers: {
    setOpenBottomToast: (state, action: PayloadAction<boolean>) => {
      state.bottomToast.open = action.payload
    },
    setBottomToastMessage: (state, action: PayloadAction<string>) => {
      state.bottomToast.message = action.payload
    },
    setCFDISyncInformation(
      state,
      action: PayloadAction<ICFDISyncInformation[]>
    ) {
      state.syncInformation.cfdis = action.payload
    },
    setComplianceSyncInformation(
      state,
      action: PayloadAction<IComplianceSyncInformation[]>
    ) {
      state.syncInformation.compliance = action.payload
    },
    setExternalLinkURL(state, action: PayloadAction<string | undefined>) {
      state.externalLinkURL = action.payload
    },
  },
})

export const {
  setOpenBottomToast,
  setBottomToastMessage,
  setCFDISyncInformation,
  setComplianceSyncInformation,
  setExternalLinkURL,
} = sharedDataSlice.actions

export default sharedDataSlice.reducer
